import React from "react";
import Form from "./Form";
import { useSignUpForm } from "./SignUpFormContext";

const FormContent = () => {
  const { getCurrentStep } = useSignUpForm();
  const step = getCurrentStep();

  return (
    <section className="flex flex-col items-center sm:gap-6 md:gap-8 gap-16 align">
      <div className="flex flex-col gap-3">
        <h4
          className="text-forest-900 text-center text-[32px] md:text-[26px] sm:text-[22px] font-normal
          md:font-medium not-italic leading-[130%] md:leading-[140%] -tracking-[0.64px] md:-tracking-[0.26px] sm:-tracking-[0.22px]"
          dangerouslySetInnerHTML={{ __html: step?.headline ?? "" }}
        />
        <p
          className="text-forest-900 text-center text-base font-normal not-italic leading-[160%]"
          dangerouslySetInnerHTML={{ __html: step?.subcopy ?? "" }}
        />
      </div>
      <Form />
    </section>
  );
};

export default FormContent;
